// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oj-c";
export var backButton = "_oj-4";
export var backIcon = "_oj-5";
export var chevronShortcut = "_oj-6";
export var container = "_oj-1";
export var editor = "_oj-8";
export var editorWrapper = "_oj-7";
export var prefix = "_oj-2";
export var searchIcon = "_oj-3";
export var suffix = "_oj-9";
export var suffixContent = "_oj-a";
export var suffixText = "_oj-b";
export var wrapper = "_oj-0";